<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-card flat>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-btn color="primary" @click="onClickCreateLicense"><v-icon>mdi-plus-circle-outline</v-icon>ライセンス作成</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table fixed-header height="400">
                        <thead>
                            <tr>
                                <th>組織名</th>
                                <th>組織略称</th>
                                <th>ライセンスコード</th>
                                <th>有効化</th>
                                <th>ライセンス数</th>
                                <th>有効期限</th>
                                <th>状態</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="license in licenses" :key="license.code" @click="onSelectedLicense(license)" :class="license.deactivated ? 'red white--text' : license.licenseInfo.activated ? '' : 'blue--text'">
                                <td>{{license.organization.name}}</td>
                                <td>{{license.organization.shortName}}</td>
                                <td>{{license.code}}</td>
                                <td>{{license.licenseInfo.activated ? "済" : "未"}}</td>
                                <td>{{license.licenseInfo.licenseNum}}</td>
                                <td>{{license.licenseInfo.toDate}}</td>
                                <td>{{license.deactivated ? "無効" : "有効"}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>
        <EditorLicense ref="editor" :licenses="licenses" />
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import EditorLicense from '@/components/setting/items/MaintenanceSystemManagerLicense';
    export default {
        components: {
            EditorLicense
        },
        data: function () {
            return {
                /** 全ライセンス */
                licenses: []
            }
        },
        created: function () {
            const self = this
            this.licenses = []
            db.collection("licenses").get().then(function(snapShot) {
                snapShot.forEach(function(doc){
                    const license = doc.data()
                    self.licenses.push(license)
                })
            })
        },
        methods: {
            /**
             * ライセンス作成ボタン押下時
             */
            onClickCreateLicense: function () {
                this.$refs.editor.show()
            },
            /**
             * ライセンス一覧からライセンス選択時
             */
            onSelectedLicense: function (license) {
                this.$refs.editor.show(license)
            }
        }
    }
</script>
